export default __webpack_public_path__ + "static/mym-ef051c7674bddac35f5c60128da197d3.jpg";